import React, { useState, useEffect } from 'react';
import './index.less';
import apis from '../../api';
import { message, Spin } from 'antd';
import { useHistory } from 'react-router-dom';
import utils from '@/common/utils';
import Empty from '@/components/core-empty';

const reportLog = (id, actType, type) => {
  let channelid, huichangid;
  if (actType === 1) {
    channelid = id;
  } else {
    huichangid = id;
  }
  const colletcorrcom = type === 1 ? 0 : 1;
  window.log &&
    window.log('yx_center', 'workbench_sidecollectionclick', JSON.stringify({ channelid, huichangid, colletcorrcom }));
};

const MarketFlow = () => {
  // const [visible, setVisible] = useState(false);
  const history = useHistory();
  const [data, setData] = useState({});
  // 1 收藏 2 推荐
  const [type, setType] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    apis
      .homeData({ type })
      .then((res) => {
        if (res && res.ret === '0') {
          setData(res.data);
          setLoading(false);
        } else {
          message.error(res.msg);
          setLoading(false);
        }
      })
      .catch((ex) => {
        console.error(ex);
        setLoading(false);
      });
  }, [type]);

  function getClassName(type) {
    switch (type && type.toString()) {
      case '1': {
        return 'green';
      }
      case '2': {
        return 'yellow';
      }
      default: {
        return 'red';
      }
    }
  }

  function toCollect(item) {
    reportLog(item.activityId, item.type, type);
    switch (item.type && item.type.toString()) {
      case '1': {
        if (item.channelType == 3) {
          utils.goto(`/platform-marketing/${item.activityId}`, 'newTab');
        }
        if (item.channelType == 4) {
          utils.goto(`/channel-service/position/${item.activityId}`, 'newTab');
        }
        break;
      }
      case '2': {
        utils.goto(
          `/activity-manage/myCreate/pools/roomlist?entry=1&activityId=${item.activityId}&from=acore&hideTab=1&id=${item.activityId}`,
          'newTab'
        );
        break;
      }
      default: {
        return '';
      }
    }
  }

  return (
    <div className="collect-wrapper">
      <div
        className="collect-block-title"
        onClick={() => {
          setType(1);
        }}
      >
        我的收藏
      </div>
      {type === 1 ? (
        <div className="collect-wrap">
          {!loading ? (
            <>
              <div className="title">
                <div className="sub-title" onClick={() => history.push(`/channel-service`)}>
                  频道
                  <span style={{ marginLeft: 8 }}>{data.channelCount}&gt;</span>
                </div>
                <div
                  className="sub-title"
                  onClick={() => history.push(`/activity-manage/myCreate/room/activityReceipt`)}
                >
                  会场
                  <span style={{ marginLeft: 8 }}>{data.roomCount}&gt;</span>
                </div>
              </div>
              {data.list && data.list.length > 0 ? (
                data.list.slice(0, 5).map((item, index) => {
                  return (
                    <div className="item" key={index} onClick={() => toCollect(item)}>
                      <span className={`item-type ${getClassName(item.type)}`}>{item.type == 1 ? '频道' : '会场'}</span>
                      <span className="item-type-grid">|</span>
                      <span className="item-inner">{item.name}</span>
                    </div>
                  );
                })
              ) : (
                <div className="collect-empty">
                  <Empty description="暂无收藏" />
                </div>
              )}
            </>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Spin />
            </div>
          )}
        </div>
      ) : (
        <>
          {!loading ? (
            <div className="collect-wrap">
              {data.list && data.list.length > 0 ? (
                data.list.slice(0, 5).map((item, index) => {
                  return (
                    <div
                      className="item"
                      key={index}
                      onClick={() => {
                        reportLog(item.activityId, item.type, type);
                        item.link && window.open(item.link);
                      }}
                    >
                      <span className={`item-type ${getClassName(item.type)}`}>{item.type == 1 ? '频道' : '会场'}</span>
                      <span className="item-inner">{item.name}</span>
                    </div>
                  );
                })
              ) : (
                <div className="collect-empty">
                  <Empty />
                </div>
              )}
            </div>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Spin />
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default MarketFlow;
